import { render, staticRenderFns } from "./VAppClientSelector.vue?vue&type=template&id=c081ab9a&scoped=true"
import script from "./VAppClientSelector.vue?vue&type=script&lang=js"
export * from "./VAppClientSelector.vue?vue&type=script&lang=js"
import style0 from "./VAppClientSelector.vue?vue&type=style&index=0&id=c081ab9a&prod&scoped=true&lang=css"
import style1 from "./VAppClientSelector.vue?vue&type=style&index=1&id=c081ab9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081ab9a",
  null
  
)

export default component.exports